import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=33c204bb&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c204bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33c204bb')) {
      api.createRecord('33c204bb', component.options)
    } else {
      api.reload('33c204bb', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=33c204bb&scoped=true&", function () {
      api.rerender('33c204bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Hgd6SS4GrFt2/JS/comp/Accordion.vue"
export default component.exports